import React, { useState, useCallback } from "react";
import Draggable from "react-draggable";
import "./Dashboard.css";

function DijonCard(props) {
  const [height, setHeight] = useState(props.height);
  const [width, setWidth] = useState(props.width);
  const [minimized, setMinimized] = useState(false);
  const [maximized, setMaximized] = useState(!!props.startMaximized);
  const [preMaxSize, setPreMaxSize] = useState(null);

  const handleStart = useCallback(() => {}, []);
  const handleDrag = useCallback(() => {}, []);
  const handleStop = useCallback(() => {}, []);

  const handleCloseCard = useCallback(() => {
    const acs = {
      ...props.activeCards,
      [props.name]: false,
    };
    props.setActiveCards(acs);
  }, [props.activeCards, props.name, props.setActiveCards]);

  const handleMinimize = useCallback(() => {
    if (maximized) setMaximized(false);
    setMinimized(!minimized);
  }, [minimized, maximized]);

  const handleMaximize = useCallback(() => {
    if (minimized) setMinimized(false);
    if (!maximized) {
      setPreMaxSize({ width, height });
      setMaximized(true);
    } else {
      if (preMaxSize) {
        setWidth(preMaxSize.width);
        setHeight(preMaxSize.height);
      }
      setMaximized(false);
    }
  }, [maximized, minimized, width, height, preMaxSize]);

  const currentWidth = maximized ? '100vw' : (width || '500px');
  const currentHeight = maximized
    ? 'calc(100vh - 40px)'
    : minimized
      ? '35px'
      : (height || '500px');

  return (
      <Draggable
        handle=".handle"
        cancel=".x-out, .minimize, .enlarge"
        defaultPosition={{
          x: props.defaultX || 20,
          y: props.defaultY || 20,
        }}
        position={maximized ? { x: 0, y: 0 } : undefined}
        scale={1}
        onStart={handleStart}
        onDrag={handleDrag}
        onStop={handleStop}
        disabled={maximized}
      >
        <div className="card"
          style={{
            zIndex: props.inFront ? 10000 : (maximized ? 9999 : 1001),
            width: currentWidth,
            height: currentHeight,
            overflow: minimized ? 'hidden' : 'scroll',
            transition: 'width 0.2s, height 0.2s',
            pointerEvents: 'all',
          }}>
          <div className="handle" style={{pointerEvents: "all"}}>
            <div
              className="x-out"
              onClick={handleCloseCard}
            >
              <div className="icon">
                <i className="x icon"></i>
              </div>
            </div>
            <div className="minimize" onClick={handleMinimize}>
              <div className="icon">
                <i className="minus icon"></i>
              </div>
            </div>
            <div className="enlarge" onClick={handleMaximize}>
              <div className="icon">
                <i className={maximized ? "compress icon" : "expand icon"}></i>
              </div>
            </div>
          </div>
          {!minimized && (
            <div className="content" style={{ height: "100%", width: "100%" }}>
              {props.content}
            </div>
          )}
        </div>
      </Draggable>
  );
}

export default DijonCard;
